import { render, staticRenderFns } from "./CurriculumChipPartnerValue.vue?vue&type=template&id=8fdde680&"
import script from "./CurriculumChipPartnerValue.vue?vue&type=script&lang=ts&"
export * from "./CurriculumChipPartnerValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports